module.exports = __webpack_public_path__ + "img/6-cctv.0d96e1fb.jpg";